import Swiper from 'swiper';
// Library layout only — the visual design lives in the element partials.
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { A11y, Keyboard, Navigation, Pagination } from 'swiper/modules';
import type { SwiperOptions } from 'swiper/types';

const perView = (root: HTMLElement, fallback: number): number => {
	const value = Number(root.dataset.perView);

	return Number.isFinite(value) && value > 0 ? value : fallback;
};

const base = (root: HTMLElement, slides: number): SwiperOptions => ({
	modules: [Navigation, Pagination, Keyboard, A11y],
	slidesPerView: 1,
	spaceBetween: 20,
	loop: root.dataset.loop === 'yes',
	keyboard: { enabled: true },
	navigation: {
		prevEl: root.querySelector<HTMLElement>('.swiper-button-prev'),
		nextEl: root.querySelector<HTMLElement>('.swiper-button-next'),
	},
	pagination: {
		el: root.querySelector<HTMLElement>('.swiper-pagination'),
		clickable: true,
	},
	breakpoints: {
		640: { slidesPerView: Math.min(2, slides) },
		1024: { slidesPerView: slides },
	},
});

export default function initSliders(): void {
	document.querySelectorAll<HTMLElement>('[data-armada-gallery]').forEach((root) => {
		new Swiper(root, base(root, perView(root, 3)));
	});
}
